import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AuthCallback from "@/components/AuthCallback";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, Protected } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Editor from "@/pages/Editor";
import DataPage from "@/pages/DataPage";
import PrintPage from "@/pages/PrintPage";
import Verify from "@/pages/Verify";
import CardEntry from "@/pages/CardEntry";
import CertSearch from "@/pages/CertSearch";
import SuperAdmin from "@/pages/SuperAdmin";
import StoreSite, { DomainSite } from "@/pages/StoreSite";
import WebsitePage from "@/pages/WebsitePage";
import Join from "@/pages/Join";
import Billing from "@/pages/Billing";
import { BACKEND_URL } from "@/lib/api";

const host = window.location.hostname;
const IS_CUSTOM_DOMAIN = host !== "localhost" && host !== new URL(BACKEND_URL).hostname;

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
          <Routes>
            <Route path="/store/:slug/*" element={<StoreSite />} />
            <Route path="/website" element={<Protected><WebsitePage /></Protected>} />
            <Route path="/join" element={<Join />} />
            <Route path="/billing" element={<Protected><Billing /></Protected>} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<CertSearch />} />
            <Route path="/verify/:rid" element={<Verify />} />
            <Route path="/admin" element={<Protected superadmin><SuperAdmin /></Protected>} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/cards" element={<Protected><CardEntry /></Protected>} />
            <Route path="/editor/:id" element={<Protected><Editor /></Protected>} />
            <Route path="/data/:id" element={<Protected><DataPage /></Protected>} />
            <Route path="/print/:id" element={<Protected><PrintPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {IS_CUSTOM_DOMAIN ? (
          <Routes><Route path="/*" element={<DomainSite />} /></Routes>
        ) : (
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
        )}
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
